import { render, staticRenderFns } from "./RequestLogisticProduct.vue?vue&type=template&id=22cc005a&"
import script from "./RequestLogisticProduct.vue?vue&type=script&lang=js&"
export * from "./RequestLogisticProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports